import axios from 'axios';
import config from '../config/config';
import links from './links';



export const service = {
    authenticate, 
    get,
    getAllModules
};

async function authenticate(payload) {
    try { 
      let apiEndpoint = "authenticate";
      // console.log(process);
      // console.log("url", process.env.REACT_APP_MODE);
      // let response = await axios.post("https://mmshawl.nyggs.com:81/" + apiEndpoint, payload);
      let response = await axios.post(links?.nkcAuthenticate + apiEndpoint, payload);
      
      if ((response && response.status === 200)) {
        return {
          status: response.status,
          message: "Success",
          data: response.data,
        };
      } else {
        console.log(" actual unauthoriesd")
        return { status: 401, message: "Unauthorised", data: null };
      }
    } catch (error) {
      console.log("error")
      console.log(error);
      return { status: 401, message: "Unauthorised", data: null };
    }
  }


//   function  authenticate(payload)
// {
//   let apiEndpoint="authenticate"
//   return axios.post("http://192.168.30.53:81/" + apiEndpoint, payload).then((response)=>{
//     if((response && response.status===200))
//     {
//       return {
//         status: response.status,
//         message: "Success",
//         data: response.data,
//       };
//     }
//     else{
//       return { status: 401, message: "Unauthorised", data: null };
//     }



//   }).catch(error=>{  return { status: 401, message: "Unauthorised", data: null }})
// }








  function get(apiEndpoint, userId) {
    return axios.get(links?.nkc + apiEndpoint )
        .then((response) => {
          console.log("ASDKJASHDLJASLDJA",response);
        //   return  Encryption.Decoder(response);
            return response;
        }).catch((err) => {
            console.log(err);

            if (err.response != undefined && err.response.status == 401) {
                // window.open('/','_self');
                console.log(err)
            } else {
                // alert('operation not able to perform');
            }
        })
}



async function getAllModules(apiEndpoint, userId) {


  // return axios.get("https://mmshawl.nyggs.com:81/api/" + apiEndpoint , getOptions())
  return axios.get(links?.nkcModuleSelection + apiEndpoint , getOptions())
      .then((response) => {
      //   return  Encryption.Decoder(response);
          return response;
      }).catch((err) => {
          console.log(err);

          if (err.response != undefined && err.response.status == 401) {
              // window.open('/','_self');
              console.log(err)
          } else {
              // alert('operation not able to perform');
          }
      })
}


function getOptions() {
  let options = {};
  // if (localStorage.getItem('token')) {
      options.headers = {
          'Authorization': 'Bearer ' + localStorage.getItem("companyToken"),
          // 'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          'userCompanyId': localStorage.getItem("companyId"),
          'userId': localStorage.getItem("userId"),
          // 'userName':"",
          'userRoleId':2,
          // 'userCode':"",
          'moduleId':2,
          // SecureMode : 2,
          // SecretKey:"bnlnZ3NfM3JwX21pY3JvczNydmljM3M="

      };
  // }
  console.log(options,"headerData")
  return options;
}